import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customerTranslate'
})
export class CustomerTranslatePipe implements PipeTransform {

  constructor(private translate : TranslateService){}

  transform(value: string, ...args: unknown[]): unknown {
    let customerLabel = 'CustomerLabels.' + value
    let customerLabelTranslated  = this.translate.instant('CustomerLabels.' + value);
		
    return customerLabel != customerLabelTranslated ? customerLabelTranslated : this.translate.instant(value);
  }

}
